import React from 'react';
import { Heart } from 'lucide-react';
export function MethodSection() {
  return <section className="bg-trust text-white py-10 md:py-24 px-4 relative overflow-hidden" data-id="element-97">
      <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-98"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-primary opacity-10 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-99"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-100">
        <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-white/10 rounded-full mb-6 md:mb-8 backdrop-blur-sm" data-id="element-101">
          <Heart className="w-7 h-7 md:w-8 md:h-8 text-primary" data-id="element-102" />
        </div>

        <h2 className="text-2xl md:text-5xl font-bold mb-4 md:mb-6" data-id="element-103">
          El Método: Conexión Primero
        </h2>

        <p className="text-base md:text-xl text-primary/90 leading-relaxed mb-8 md:mb-10 max-w-3xl mx-auto font-light" data-id="element-104">
          La guía se basa en un principio fundamental:{' '}
          <strong className="font-semibold text-white" data-id="element-105">
            no puedes influir en alguien con quien no estás conectado.
          </strong>
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 text-left" data-id="element-106">
          <div className="bg-white/10 backdrop-blur-sm p-5 md:p-6 rounded-xl border border-white/20" data-id="element-107">
            <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3 text-white" data-id="element-108">
              1. Comprender
            </h3>
            <p className="text-primary/80 text-sm leading-relaxed" data-id="element-109">
              Entender por qué el celular es tan adictivo para su cerebro en
              desarrollo, sin juzgar.
            </p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm p-5 md:p-6 rounded-xl border border-white/20" data-id="element-110">
            <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3 text-white" data-id="element-111">
              2. Conectar
            </h3>
            <p className="text-primary/80 text-sm leading-relaxed" data-id="element-112">
              Técnicas sutiles para entrar en su mundo y reconstruir el puente
              de comunicación entre ustedes.
            </p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm p-5 md:p-6 rounded-xl border border-white/20" data-id="element-113">
            <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3 text-white" data-id="element-114">
              3. Corregir
            </h3>
            <p className="text-primary/80 text-sm leading-relaxed" data-id="element-115">
              Establecer límites firmes pero amorosos, creando acuerdos mutuos
              en lugar de imposiciones.
            </p>
          </div>
        </div>
      </div>
    </section>;
}